import { useCommonServiceCommonLocationsCountriesRetrieve } from '@insurance/api/queries'
import { normalize } from '@shared/utils'
import { Select, SelectProps } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  resident?: boolean
  queryParams?: Parameters<
    typeof useCommonServiceCommonLocationsCountriesRetrieve
  >[0]
} & SelectProps

export const CountrySelect = ({
  resident,
  value,
  queryParams,
  onChange,
  ...props
}: Props) => {
  const { t, i18n } = useTranslation()

  const { data, isLoading } = useCommonServiceCommonLocationsCountriesRetrieve(
    queryParams || {},
    [queryParams, i18n.language]
  )

  const options = Object.entries(data || {}).map(([value, label]) => ({
    value,
    label
  }))

  useEffect(() => {
    if (!resident && value === 'MD') onChange?.(null)
  }, [resident])

  return (
    <Select
      placeholder={t('country')}
      options={options}
      loading={isLoading}
      value={value}
      onChange={onChange}
      showSearch
      filterOption={(input, option) =>
        normalize(option?.label?.toString() || '')?.includes(normalize(input))
      }
      {...props}
    />
  )
}
